module.exports = __webpack_public_path__ + "img/estancia-isla-navidad.a6182bf0.jpg";